/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ArrowUp: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="arrow-up" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M623.3333333333333 340V861.3333333333333L419.3333333333333 657.3333333333334L340 736.6666666666667L680 1076.6666666666667L1020 736.6666666666667L940.6666666666669 657.3333333333334L736.6666666666666 861.3333333333333V340H623.3333333333333z" : "M498.6666666666667 272V689.0666666666666L335.4666666666667 525.8666666666667L272 589.3333333333333L544 861.3333333333333L816 589.3333333333333L752.5333333333334 525.8666666666667L589.3333333333334 689.0666666666666V272H498.6666666666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ArrowUp.displayName = `Blueprint5.Icon.ArrowUp`;
export default ArrowUp;
